import { createStyles } from "@mantine/core";
import { colors, pxToRem } from "theme";

export const useStyles = createStyles((theme) => ({
  input: {
    border: `1px solid ${colors.grey[70]}`,
    borderRadius: pxToRem[2],
    "&:focus": {
      borderColor: theme.other.primary[60],
    },
  },
}));
